"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ArticleStatus = {
    none: 0,
    published: 2,
    draft: 1,
    archive: 4
};
exports.ArticleStatus = ArticleStatus;
var CommentStatus = {
    approved: 1,
    spam: 2,
    reported: 4,
    flagged: 8,
    unapproved: 16
};
exports.CommentStatus = CommentStatus;
